import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  expenses: [],
  tempExpenses: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const expenseSlice = createSlice({
  name: "expenses",
  initialState,
  reducers: {
    setExpenses(state, action) {
      state.expenses = action.payload;
      state.isLoading = false;
    },
    setTempExpenses(state, action) {
      state.tempExpenses = action.payload;
    },
    addExpense(state, action) {
      state.expenses.push(action.payload);
      state.tempExpenses.push(action.payload);
    },
    setExpensePagination(state, action) {
      state.pagination = action.payload;
    },
    updateExpense(state, action) {
      const { index, expense } = action.payload;
      console.log(index, expense);
      state.expenses?.splice(index, 1, expense);
      state.tempExpenses?.splice(index, 1, expense);
    },
    deleteExpense(state, action) {
      const { index } = action.payload;
      state.expenses.splice(index, 1);
      state.tempExpenses.splice(index, 1);
    },
    setExpenseIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setExpenses,
  setTempExpenses,
  addExpense,
  updateExpense,
  setExpensePagination,
  deleteExpense,
  setExpenseIsLoading,
} = expenseSlice.actions;
export default expenseSlice.reducer;
